export { default } from './src/WrapperImage';
export * from './src/types.d';
